import DeleteInvoiceForm from 'src/components/Forms/DeleteInvoiceForm';
import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';

const DeleteInvoiceModal = () => (
  <ModalBase
    name={MODALS.deleteInvoice}
    size={MODALS_SIZE.small}
    height="60px"
    form={FORM.get_invoice}>
    <DeleteInvoiceForm />
  </ModalBase>
);

export default DeleteInvoiceModal;
